"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = void 0;
var async_1 = require("../scheduler/async");
var delayWhen_1 = require("./delayWhen");
var timer_1 = require("../observable/timer");
function delay(due, scheduler) {
  if (scheduler === void 0) {
    scheduler = async_1.asyncScheduler;
  }
  var duration = timer_1.timer(due, scheduler);
  return delayWhen_1.delayWhen(function () {
    return duration;
  });
}
exports.delay = delay;
